import { render, staticRenderFns } from "./AlreadyInProgressDeliveries.vue?vue&type=template&id=070a3668&scoped=true&"
import script from "./AlreadyInProgressDeliveries.vue?vue&type=script&lang=js&"
export * from "./AlreadyInProgressDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./AlreadyInProgressDeliveries.vue?vue&type=style&index=0&id=070a3668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a3668",
  null
  
)

export default component.exports